import type { ComponentPropsWithRef } from 'react'

export interface ImageProps extends ComponentPropsWithRef<'img'> {}

export function Image({ loading = 'lazy', ...restProps }: ImageProps) {
    return (
        <img
            loading={loading}
            {...restProps}
        />
    )
}
